import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'orderBy',
  standalone: false,
})
export class OrderByPipe<T> implements PipeTransform {
  transform(value: T[], propertyName: keyof T & string): T[] {
    if (propertyName) {
      return value.sort((a: T, b: T) => a[propertyName].toString().localeCompare(b[propertyName].toString()));
    } else {
      return value;
    }
  }
}
